<template>
  <v-timeline-item :color="item.color" :icon="item.itemType == 'Anúncio' ? 'mdi-currency-usd' : 'mdi-newspaper-plus'">
    <v-card :color="item.color" dark>
      <v-card-text @click="preview(item)">
        <v-btn class="remove" @click="remove(item._id)" x-small icon><v-icon dark color="#F8BBD0">mdi-close</v-icon></v-btn>
        <div><b>Nome:</b> {{ item.name || item.link }}</div>

        <div><b>Parceiro:</b> {{ item.user.name }}</div>

        <div>
          <b>Início:</b> {{ new Date(item.startDate).toLocaleDateString() }}
        </div>

        <div>
          <b>Término:</b> {{ new Date(item.endDate).toLocaleDateString() }}
        </div>

        <div>
          <b>Duração na tela:</b> {{ item.time }} segundos
        </div>

        <div class="mt-2" v-if="hasLetreiroSelected">
          <v-expansion-panels flat>
            <v-expansion-panel>
              <v-expansion-panel-header class="px-0 py-1">
                <span class="text-caption font-weight-medium text-center d-block">Letreiro</span>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="px-0 py-1">
                <v-checkbox
                  v-model="item.showLetreiro"
                  label="Exibir letreiro"
                  dense
                  hide-details
                  class="mt-0 mb-2"
                  @change="updateShowLetreiro"
                ></v-checkbox>

                <div v-if="item.showLetreiro">
                  <div class="text-caption mb-1">Posição do letreiro:</div>
                  <v-radio-group
                    v-model="item.letreiroPosition"
                    row
                    dense
                    hide-details
                    class="mt-0"
                    @change="updateLetreiroPosition"
                  >
                    <v-radio label="TOPO" value="TOPO" color="primary"></v-radio>
                    <v-radio label="RODAPÉ" value="RODAPÉ" color="primary"></v-radio>
                  </v-radio-group>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>

      </v-card-text>

      <v-card-text class="white text--primary" v-if="item.itemType == 'Notícia'">
        <p>{{ item.text }}</p>
      </v-card-text>
    </v-card>
  </v-timeline-item>
</template>

<script>
import _ from 'lodash'
export default {
  props: {
    item: { type: Object, required: true },
    hasLetreiroSelected: { type: Boolean, default: false }
  },
  methods: {
    preview() {
      // const tempoEmSegundosPadraoDosTemplates = {
      //   "Template 1": { total: 10000 + (this.item.text.length * 40), aditional: 11 * 40 },
      //   "Template 2": { total: 10000 + (this.item?.paragraphs[0]?.length * 40), aditional: 87 * 40 },
      //   "Template 3": { total: 2000 + 10000 + (this.item?.paragraphs[1]?.length * 40), aditional: 87 * 40 },
      //   "Template 4": { total: 14000 + (this.item?.paragraphs[2]?.length * 40), aditional: 87 * 40 }
      // }
      // const total = this.item.templates.reduce((acc, template) => acc += tempoEmSegundosPadraoDosTemplates[template.name].total, 0)
      // console.log(total + tempoEmSegundosPadraoDosTemplates[this.item.templates[this.item.templates.length - 1].name].aditional)
      // if (item.itemType == 'Anúncio') {
      //   this.$store.state.playlist.type = 'Anúncios'
      //   this.$store.state.playlist.previewAds = item
      // } else {
      //   this.$store.state.playlist.type = 'Notícias'
      //   this.$store.state.playlist.preview = item;
      // }
      // this.$store.state.templates.items = item.templates
      // this.$store.state.news = item

    },
    updateShowLetreiro() {
      // Garantir que a propriedade seja reativa
      this.$set(this.item, 'showLetreiro', this.item.showLetreiro)
    },
    updateLetreiroPosition() {
      // Garantir que a propriedade seja reativa
      this.$set(this.item, 'letreiroPosition', this.item.letreiroPosition)
    },
    remove(id) {
      const propName = this.item.itemType == 'Notícia' ? 'itemsNews' : 'itemsAds'
      const index = _.findIndex(this.$store.state.playlist.itemsSelected, {
        _id: id,
      });

      // remove caso seja uma notícia de previsão do tempo
      const item = this.$store.state.playlist.itemsSelected.splice(index, 1)[0]
      if(item.name === "Previsão do Tempo") return
      this.$store.state.playlist[propName].push(item)
    }
  }
};
</script>
<style scoped>
.remove {
  position: absolute;
  right: 8px;
  top: 8px;
}

.white {
  padding-bottom: 1px;
}
</style>
